import Cvv from '@images/svg-icons/cvv.svg';
import CvvAmex from '@images/svg-icons/cvvAmex.svg';

const CvvTooltip = () => {
    return (
        <div className="cvv-tooltip">
            <p className="cvv-tooltip-trigger">
                <b>Where can I find the security code?</b>
            </p>

            <div className="cvv-tooltip-container">
                <div className="cvv-tooltip-title">
                    <b>What is a Card Validation Value (CVV)?</b>
                </div>

                <div className="cvv-tooltip-details">
                    <p>
                        For <b>Discover</b>, <b>MasterCard</b> and <b>Visa</b>, enter the last three
                        digits on the signature strip.
                    </p>
                    <Cvv />

                    <p>
                        For <b>American Express</b>, enter the four digits in small print on the
                        front of the card.
                    </p>
                    <CvvAmex />
                </div>
            </div>
        </div>
    );
};

export default CvvTooltip;
